document.addEventListener('DOMContentLoaded', () => {
  const intervalCategoryIcons = setInterval(() => {
    if (window.Swiper) {
      clearInterval(intervalCategoryIcons);
      const carousels = document.querySelectorAll('[data-category-icons-swiper]');
      carousels.forEach((carousel) => {
        new Swiper(carousel, {
          on: {
            init: function (swiper) {
              swiper.el.classList.add('swiper-initialized');
            },
          },
          slidesPerView: 2.2,
          spaceBetween: 10,
          watchOverflow: true,
          speed: 700,
          navigation: {
            nextEl: carousel.querySelector('.swiper-button-next'),
            prevEl: carousel.querySelector('.swiper-button-prev'),
          },
          autoplay: {
            delay: 3000,
            disableOnInteraction: false
          },
          breakpoints: {
            500: {
              slidesPerView: 4.2,
              spaceBetween: 15
            },
            768: {
              slidesPerView: 5.5,
              spaceBetween: 20
            },
            1024: {
              slidesPerView: 8,
              spaceBetween: 25
            }
          }
        });
        
        // Safety check to ensure class is added
        if (carousel.classList.contains('swiper') && !carousel.classList.contains('swiper-initialized')) {
          if (carousel.swiper && carousel.swiper.initialized) {
            carousel.classList.add('swiper-initialized');
          }
        }
      });
    }
  }, 100);
});